var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.get_classes()},_vm._l((_vm.get_block(_vm.block, _vm.seat)),function(tile,i){return _c('TileImage',{key:i,attrs:{"tile":tile.tile,"type":tile.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }